module.exports = require('./encrypt')
